import * as React from 'react';
import { ContainerType } from '../ContainerComponents/ContainerPage';
import Checkbox from '../../components/Checkbox';
import {
  CheckboxLabel,
  VytalCheckboxLabelContainer,
} from '../../pages/AdminStoreDetail/Menu/ProductItem/ProductOrderSheet/ExtraSelector/ExtraGroupEditModal/styled';
import { ResponsiveTable } from '../../components/Layout';
import { IconButton } from '../../components/Button/Button';
import { FaEdit, FaMoneyBill } from 'react-icons/fa';
import { centsToPrice } from '@/utils/formatter';
import { Button } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';
import { MultiSelect } from '@mantine/core';
import { allUserCountriesQuery } from '../../graphql/queries';
import { useQuery } from '@apollo/client';
import i18n from '@/utils/i18n';

type SaveCallback = (arr: any[]) => any;

type ContainerInformationEditProps = {
  containerTypes: ContainerType[];
  getContainerInformation: Function;
  updateContainerInformation: Function;
  storeId: string;
  currency: string | null;
  resetContainerInformation: Function;
  saveContainerInformation: SaveCallback;
  country: string;
};

export const ContainerInformationForm: React.FC<
  ContainerInformationEditProps
> = ({
  containerTypes: allContainerTypes,
  getContainerInformation,
  updateContainerInformation,
  storeId,
  currency,
  resetContainerInformation,
  saveContainerInformation,
  country,
}) => {
  const [editStoreLostCost, setEditStoreLostCost] = useState(false);
  const [editContainerTypes, setEditContainerTypes] = useState([] as any[]);
  const [countryFilter, setCountryFilter] = useState<string[]>(
    country != null && country.length > 0 ? [country] : [],
  );
  const [onlyShowAccepted, setOnlyShowAccepted] = useState(true);
  const { data: countriesData = { __type: { enumValues: [] } } } = useQuery(
    allUserCountriesQuery,
  );
  const countries = countriesData.__type.enumValues.map(
    (country: any) => country.name,
  );

  React.useEffect(() => {
    if (
      country != null &&
      country.length > 0 &&
      !countryFilter.includes(country)
    ) {
      setCountryFilter(countryFilter.concat([country]));
    }
  }, [country]);

  console.log({ countryFilter, country });

  const containerTypes = allContainerTypes.filter((ct) => {
    if (
      countryFilter.length > 0 &&
      !countryFilter.some((country) =>
        (ct.countryCodes || []).includes(country),
      )
    ) {
      return false;
    }
    if (onlyShowAccepted) {
      const containerInfo = getContainerInformation(ct.id);
      if (!containerInfo || !containerInfo.isAccepted) {
        return false;
      }
    }
    return true;
  });
  function onStoreLostCostUpperChange(containerTypeId: number, value: string) {
    setEditContainerTypes((oldState) => {
      const newState = [...oldState];
      let index = newState.findIndex(
        (c) => c.containerTypeId === containerTypeId,
      );
      if (index === -1) {
        throw Error(`Unexpected container type id ${containerTypeId}`);
      }
      newState[index].storeLostCostUpper = value.replace(/[^0-9]/g, '');
      return newState;
    });
  }

  function onStoreLostCostLowerChange(containerTypeId: number, value: string) {
    setEditContainerTypes((oldState) => {
      const newState = [...oldState];
      let index = newState.findIndex(
        (c) => c.containerTypeId === containerTypeId,
      );
      if (index === -1) {
        throw Error(`Unexpected container type id ${containerTypeId}`);
      }
      newState[index].storeLostCostLower = value.replace(/[^0-9]/g, '');
      return newState;
    });
  }

  function renderEditStoreLostCostDialog() {
    if (!editStoreLostCost) {
      return null;
    }
    if (editContainerTypes.length === 0) {
      setEditContainerTypes(
        containerTypes.map((_) => {
          const info = getContainerInformation(_.id);
          return {
            containerTypeId: _.id,
            storeLostCost: info.storeLostCost,
            storeLostCostLower: info.storeLostCostLower || '0',
            storeLostCostUpper: info.storeLostCostUpper || '0',
          };
        }),
      );
      return null;
    }
    console.info(editContainerTypes);
    const execute = () => {
      saveContainerInformation(editContainerTypes);
    };

    const hide = () => {
      setEditContainerTypes([]);
      setEditStoreLostCost(false);
    };

    const footer = (
      <div>
        <Button onClick={execute} color="primary">
          {i18n.t('Common:save')}
        </Button>
        <Button onClick={hide} color="secondary">
          {i18n.t('Common:cancel')}
        </Button>
      </div>
    );

    return (
      <Dialog
        header={i18n.t('Common:editStoreLostCostForContainerParts')}
        visible={editStoreLostCost}
        onHide={hide}
        style={{ minWidth: '50vw' }}
        footer={footer}
      >
        <ResponsiveTable>
          <thead>
            <tr>
              <th>{i18n.t('Common:container')}</th>
              <th>{i18n.t('ContainerInformation:costComplete')}</th>
              <th>{i18n.t('ContainerInformation:costUpper')}</th>
              <th>{i18n.t('ContainerInformation:costLower')}</th>
            </tr>
          </thead>
          <tbody>
            {containerTypes.map((_) => {
              const containerInfo = editContainerTypes.find(
                (c) => c.containerTypeId === _.id,
              );
              return (
                <tr key={_.id}>
                  <td>{_.name}</td>
                  <td>
                    <div className="input-group">
                      <span className="input-group-text">
                        {' '}
                        {centsToPrice(
                          parseInt(containerInfo.storeLostCost),
                          currency,
                        )}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <input
                        value={containerInfo.storeLostCostUpper}
                        type="text"
                        className="form-control"
                        onChange={(e) =>
                          onStoreLostCostUpperChange(
                            containerInfo.containerTypeId,
                            e.target.value,
                          )
                        }
                      />
                      <span className="input-group-text">
                        {' '}
                        {centsToPrice(
                          parseInt(containerInfo.storeLostCostUpper),
                          currency,
                        )}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className="input-group">
                      <input
                        value={containerInfo.storeLostCostLower}
                        type="text"
                        className="form-control"
                        onChange={(e) =>
                          onStoreLostCostLowerChange(
                            containerInfo.containerTypeId,
                            e.target.value,
                          )
                        }
                      />
                      <span className="input-group-text">
                        {' '}
                        {centsToPrice(
                          parseInt(containerInfo.storeLostCostLower),
                          currency,
                        )}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </ResponsiveTable>
      </Dialog>
    );
  }

  return (
    <>
      {' '}
      <h5>{i18n.t('ContainerInformation:filters')}</h5>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon1">
          {i18n.t('ContainerInformation:filterByCountry')}
        </span>
        <MultiSelect
          data={countries}
          searchable
          value={countryFilter}
          onChange={(value: string[]) => setCountryFilter(value)}
        />
      </div>
      <div className="input-group mb-3">
        <VytalCheckboxLabelContainer className="mt-2">
          <Checkbox
            checked={onlyShowAccepted}
            onClick={() => setOnlyShowAccepted(!onlyShowAccepted)}
          />
          <CheckboxLabel onClick={() => setOnlyShowAccepted(!onlyShowAccepted)}>
            {i18n.t('ContainerInformation:onlyShowAcceptedContainerTypes')}
          </CheckboxLabel>
        </VytalCheckboxLabelContainer>
      </div>
      <ResponsiveTable>
        <thead>
          <tr>
            <th>{i18n.t('Common:selected')}</th>
            <th>{i18n.t('Common:container')}</th>
            <th>{i18n.t('ContainerInformation:transactionPrice')}</th>
            <th>{i18n.t('ContainerInformation:storeLostCost')}</th>
          </tr>
        </thead>
        <tbody>
          {containerTypes.map((_) => {
            const containerInfo = getContainerInformation(_.id);

            const onTransactionPriceChange = (e: any) => {
              const transactionPrice = e.target.value
                .replace(/[^0-9.]/g, '')
                .replace(/(\.[0-9]*)\./g, '$1');
              updateContainerInformation(_.id, {
                transactionPrice: transactionPrice,
              });
            };

            const onIsUnwantedChange = (e: any) => {
              updateContainerInformation(_.id, {
                isUnwanted: !containerInfo.isUnwanted,
              });
            };

            const onIsSelectedChange = (e: any) => {
              updateContainerInformation(_.id, {
                isSelected: !containerInfo.isSelected,
              });
            };

            const onStoreLostCostChange = (e: any) => {
              updateContainerInformation(_.id, {
                storeLostCost: e.target.value.replace(/[^0-9]/g, ''),
              });
            };

            return (
              <tr key={_.id}>
                <td>
                  <VytalCheckboxLabelContainer className="mt-2">
                    <Checkbox
                      checked={containerInfo.isSelected || false}
                      onClick={onIsSelectedChange}
                    />
                  </VytalCheckboxLabelContainer>
                </td>
                <td>{_.name}</td>
                <td>
                  <div className="input-group">
                    <input
                      value={containerInfo.transactionPrice}
                      type="text"
                      className="form-control"
                      onChange={onTransactionPriceChange}
                    />
                    <span className="input-group-text">
                      {' '}
                      {centsToPrice(
                        parseFloat(containerInfo.transactionPrice) * 100,
                        currency,
                        3,
                      )}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="input-group">
                    <input
                      value={containerInfo.storeLostCost}
                      type="text"
                      className="form-control"
                      onChange={onStoreLostCostChange}
                    />
                    <span className="input-group-text">
                      {' '}
                      {centsToPrice(
                        parseInt(containerInfo.storeLostCost),
                        currency,
                      )}
                    </span>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </ResponsiveTable>
      <IconButton
        icon={<FaEdit />}
        tag="a"
        onClick={() => setEditStoreLostCost(true)}
        className="my-1 me-3"
        label={i18n.t('StoreDetail:editStoreLostCosts')}
      />
      <IconButton
        icon={<FaMoneyBill />}
        tag="a"
        onClick={() => resetContainerInformation()}
        className="my-1 me-3"
        label={i18n.t('StoreDetail:resetSelectedPrices')}
      />
      <IconButton
        icon={<FaMoneyBill />}
        tag="a"
        onClick={() => resetContainerInformation(true)}
        className="my-1 me-3"
        label={i18n.t('StoreDetail:resetAllPrices')}
      />
      {renderEditStoreLostCostDialog()}
    </>
  );
};
